import { memo } from "react";
import { useI18n } from "@/i18n";
import { colors, spacing, typography, transitions } from "@/design-system/tokens";

export const Footer = memo(function Footer() {
  const { t } = useI18n();

  const productLinks = [
    { label: t.footer.links.features, href: "#features" },
    { label: t.footer.links.pricing, href: "#pricing" },
  ];

  const legalLinks = [
    { label: t.footer.links.privacy, href: "#" },
  ];

  return (
    <footer style={{ background: "#0a0a0a", borderTop: "1px solid rgba(255,255,255,0.06)", padding: `${spacing["3xl"]} ${spacing.xl} ${spacing.xl}` }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", display: "flex", flexDirection: "column", gap: spacing["3xl"] }}>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: spacing["2xl"] }} className="footer-grid">
          <div style={{ display: "flex", flexDirection: "column", gap: spacing.lg }}>
            <FooterLogo />
            <p style={{ fontFamily: typography.fontFamily, fontSize: typography.size.sm, color: "rgba(255,255,255,0.45)", margin: 0, lineHeight: 1.7, maxWidth: "260px" }}>
              {t.footer.tagline}
            </p>
          </div>
          <FooterColumn title={t.footer.product} links={productLinks} />
          <FooterColumn title={t.footer.resources} links={legalLinks} />
        </div>

        <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: spacing.xl, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <p style={{ fontFamily: typography.fontFamily, fontSize: typography.size.xs, color: "rgba(255,255,255,0.3)", margin: 0 }}>
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
});

const FooterLogo = memo(function FooterLogo() {
  return (
    <a href="/" aria-label="Nexo-Warehouse home" style={{ display: "flex", alignItems: "center", gap: spacing.sm, textDecoration: "none" }}>
      <div style={{ width: "32px", height: "32px", background: colors.primary, borderRadius: "7px", display: "flex", alignItems: "center", justifyContent: "center" }} aria-hidden="true">
        <svg width="17" height="17" viewBox="0 0 20 20" fill="none">
          <path d="M3 7L10 3L17 7V13L10 17L3 13V7Z" stroke="white" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M10 3V17M3 7L17 13M17 7L3 13" stroke="white" strokeWidth="1.2" strokeOpacity="0.6" />
        </svg>
      </div>
      <span style={{ fontFamily: typography.fontFamily, fontSize: typography.size.base, fontWeight: typography.weight.bold, color: "#fff", letterSpacing: "-0.02em" }}>
        Nexo-Warehouse
      </span>
    </a>
  );
});

function FooterColumn({ title, links }: { title: string; links: { label: string; href: string }[] }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: spacing.md }}>
      <h3 style={{ fontFamily: typography.fontFamily, fontSize: typography.size.xs, fontWeight: typography.weight.bold, color: "rgba(255,255,255,0.5)", margin: 0, textTransform: "uppercase", letterSpacing: "0.1em" }}>
        {title}
      </h3>
      <ul role="list" style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: spacing.sm }}>
        {links.map(link => (
          <li key={link.label}>
            <a href={link.href} style={{ fontFamily: typography.fontFamily, fontSize: typography.size.sm, color: "rgba(255,255,255,0.55)", textDecoration: "none", transition: `color ${transitions.fast}` }} onMouseEnter={e => ((e.currentTarget as HTMLAnchorElement).style.color = "#fff")} onMouseLeave={e => ((e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.55)")}>
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
